import * as React from 'react';
import { CreditCard, GiftCard } from '@one-thd/sui-icons';

export type TCards =
  | 'AX'
  | 'AMEX'
  | 'DS'
  | 'DISC'
  | 'HD'
  | 'HDCON'
  | 'HDCOM'
  | 'GC'
  | 'MA'
  | 'VI'
  | 'VISA'
  | 'HP'
  | 'HR'
  | 'HC'
  | 'HA'
  | 'CM'
  | 'CC'
  | 'PPAL'
  | 'PP'
  | 'PERK_GC'
  | 'PD'
  | 'MT'
  | 'EC'
  | 'EH'
  | 'HH'
  | 'HB'
  | 'HM'
  | 'HI'
  | 'DB'
  | 'GR'
  | 'CK'
  | 'EK'
  | 'MC'
  | 'CS';

export const ccImages: {
  [key in TCards]: (height: number, width: number) => JSX.Element | string;
} = {
  AX: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="amax-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-amex.png"
    />
  ),
  AMEX: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="amax-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-amex.png"
    />
  ),
  DS: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="discover-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-discover.png"
    />
  ),
  DISC: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="discover-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-discover.png"
    />
  ),
  HD: () => 'HD',
  HDCON: () => 'HD',
  HDCOM: () => 'HD',
  GC: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="homedepot-gift-card"
      src="https://assets.thdstatic.com/images/v1/HD_Gift.png"
    />
  ),
  MA: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="mastercard"
      src="https://assets.thdstatic.com/images/v1/credit-card-mastercard.png"
    />
  ),
  VI: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="visa-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-visa.png"
    />
  ),
  VISA: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="visa-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-visa.png"
    />
  ),
  HP: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="prox-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-prox.png"
    />
  ),
  HR: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="commercial-revolving-charge-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-commercial-revolving.png"
    />
  ),
  HC: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="consumer-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-hd-consumer.png"
    />
  ),
  HA: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="pro-purchase-card"
      src="https://assets.thdstatic.com/images/v1/credit-card-pro-purchase.png"
    />
  ),
  CM: () => 'MC',
  CC: () => 'MC',
  PPAL: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="paypal-mark"
      src="https://assets.thdstatic.com/images/v1/paypal-mark.png"
    />
  ),
  PP: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="paypal-mark"
      src="https://assets.thdstatic.com/images/v1/paypal-mark.png"
    />
  ),
  PERK_GC: (height: number, width: number) => (
    <img
      height={height}
      width={width}
      alt="pro-xtra-rewards-card"
      src="https://assets.thdstatic.com/images/v1/pro-xtra-rewards.png"
    />
  ),
  PD: () => <CreditCard />,
  MT: () => <CreditCard />,
  EC: () => <CreditCard />,
  EH: () => <CreditCard />,
  HH: () => <CreditCard />,
  HB: () => <CreditCard />,
  HM: () => <CreditCard />,
  HI: () => <CreditCard />,
  DB: () => <CreditCard />,
  CS: () => <CreditCard />, // unknown type - going with CreditCard until CS is figure out
  GR: () => <GiftCard />,
  CK: () => 'CK',
  EK: () => 'EK',
  MC: () => 'MC',
  // {CK: (height: number, width: number) => <img alt={'CheckingAccount'} src={} />},
  // {EK: (height: number, width: number) => <img alt={'CheckingAccount'} src={} />},
};

export const returnCCImage = (
  tenderType: TCards,
  height: number,
  width: number,
  multiplierFlag?: boolean,
) => {
  if (ccImages[tenderType] === undefined) {
    return tenderType;
  }
  if (multiplierFlag && tenderType === 'HR') {
    return (
      <img
        height={height}
        width={width}
        alt="Pro extra credit card 4x multiplier"
        src="https://assets.thdstatic.com/images/v1/Crc_4x_Card.png"
      />
    );
  }
  return ccImages[tenderType](height, width);
};
